import DOMPurify from 'dompurify'

import { classNames } from '@/utils/helpers'
import { sanitizeHTML } from '@/utils/html'

function stripHTMLTags(input: string): string {
  return input.replace(/<\/?[^>]+(>|$)/g, '')
}

const formatAndSanitizeText = (
  text: string,
  matchedKeywords?: string,
  clickable = true,
) => {
  // Format the text to HTML
  const formattedText = DOMPurify.sanitize(text)

  // Sanitize the formatted HTML
  const sanitizedHTML = sanitizeHTML(formattedText, clickable)

  if (!matchedKeywords) {
    return sanitizedHTML
  }

  // Highlight searched keywords
  const highlightedHTML = highlightKeywords(sanitizedHTML, matchedKeywords)

  return highlightedHTML
}

const highlightKeywords = (html: string, keywords: string) => {
  const sanitizedKeywords = DOMPurify.sanitize(keywords, { ALLOWED_TAGS: [] })
  const sanitizedHTML = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  })

  const escapedKeywords = sanitizedKeywords.replace(
    /[-/\\^$*+?.()|[\]{}]/g,
    '\\$&',
  )

  const highlightedHTML = sanitizedHTML.replace(
    new RegExp(`(${escapedKeywords})`, 'gi'),
    '<span class="bg-primary-500 text-white">$1</span>',
  )

  return highlightedHTML
}

export const SafeFormattedText = ({
  text,
  clickable = true,
  plain,
  matchedKeywords,
  className,
  testId,
}: {
  text: string
  clickable?: boolean
  plain?: boolean
  matchedKeywords?: string
  className?: string
  testId?: string
}) => {
  const textToUse = plain ? stripHTMLTags(text) : text

  const formattedAndSanitizedText = formatAndSanitizeText(
    textToUse,
    matchedKeywords,
    clickable,
  )

  return (
    <span
      className={classNames(
        'm-possible-markdown',
        plain && 'plain whitespace-no-wrap',
        className,
      )}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: formattedAndSanitizedText }}
    />
  )
}
